const getDefaultLogsState = () => {
  return {
    allLogs: [],
  }
}

export default getDefaultLogsState()
export { getDefaultLogsState }
